// extracted by mini-css-extract-plugin
export default {"reviewsSummary":"_88jgow"};